import { APIcallerv2 } from './APIcaller';

export const openIntercomMessengerSession = () =>
  APIcallerv2.apiPost('/intercom/messenger-session', {});
